import Vue from 'vue'
import VueRouter from 'vue-router'
import Wizard from '@/views/Wizard.vue'
import Sucesso from '@/views/Sucesso.vue'
import SponsorCapture from '@/views/SponsorCapture.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/sucesso/:protocol',      name: 'sucesso',         component: Sucesso },
    { path: '/:username',              name: 'sponsor-capture', component: SponsorCapture },
    { path: '/',                       name: 'wizard',          component: Wizard },
    { path: '*',                       redirect: '/' },
  ],
  scrollBehavior() { return { x: 0, y: 0 } },
})

export default router
